import { compact } from 'lodash'

/**
 * Generates the tip options for the default tip option select component from the tip_values settings.
 * It filters out any null values from the tip_values array and maps the remaining values to an object with a name and uuid key.
 *
 */
export const generateTipOptions = (tip_values = []) => {
  const tipValuesOptions = tip_values?.map((option) => {
    if (!option) return null

    const stringOption = String(option)

    return {
      name: stringOption,
      uuid: stringOption,
    }
  })

  // Adds a default option to the tip options.
  // we cannot use the null value as a default option because the select component does not support null values, so we use -1 instead, which is converted to null in the handleChangeDefaultSelectedTipOption function.
  const tipOptionsWithDefaultOption = [
    { name: 'None', uuid: -1 },
    ...compact(tipValuesOptions),
  ]

  return tipOptionsWithDefaultOption
}

/**
 * Returns the default tip option based on the selected tip option.
 * Default tip options is returned only if the selected tip option is included in the tip_values.
 */

export const getDefaultTipOpion = (
  tip_values = [],
  selected_tip_option
) => {
  // if the selected tip option is null, we return -1, which is the default option
  if (selected_tip_option === null) {
    return -1
  }

  const nonNullTipValues = compact(tip_values)

  if (nonNullTipValues.includes(selected_tip_option)) {
    return String(selected_tip_option)
  }

  return null
}

/**
 * Returns the default selected tip option key.
 * It's used to manage key in the default tip option select component.
 */

export const getDefaultTipOptionKey = (
  tip_values = [],
  selected_tip_option
) => {
  const isSelectedTipOptionInTipValues = tip_values.includes(
    selected_tip_option
  )

  return isSelectedTipOptionInTipValues ? selected_tip_option : null
}

export const tipConfigurationsUtils = {
  generateTipOptions,
  getDefaultTipOpion,
  getDefaultTipOptionKey,
}
